import { render, staticRenderFns } from "./AuthUser.vue?vue&type=template&id=12374f8d&scoped=true&"
import script from "./AuthUser.vue?vue&type=script&lang=js&"
export * from "./AuthUser.vue?vue&type=script&lang=js&"
import style0 from "./AuthUser.vue?vue&type=style&index=0&id=12374f8d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12374f8d",
  null
  
)

export default component.exports